/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _CapillarityBloodGlucoseEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import { ToastMessage } from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import CapillarityBloodGlucoseMeasuredJournalEvent from "core/models/capillarity-blood-glucose-measured-journal-event";
import SessionService from "core/services/session";
import { BufferedChangeset } from "ember-changeset/types";
import { IntlService } from "ember-intl";
let CapillarityBloodGlucoseEditionFormComponent = (_class = (_CapillarityBloodGlucoseEditionFormComponent = class CapillarityBloodGlucoseEditionFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _defineProperty(this, "inputStyles", "!mt-[-12px]");
    _defineProperty(this, "unitTextStyles", "!pt-[32px]");
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _initializerDefineProperty(this, "bloodGlucoseByGram", _descriptor3, this);
    _initializerDefineProperty(this, "bloodGlucoseByMmol", _descriptor4, this);
  }
  get validations() {
    return this.journalEventClass.validations(this.intl);
  }
  get model() {
    // eslint-disable-next-line parog-web/no-use-of-model-in-crud-forc
    const model = super.model;
    if (this.isNewMode) {
      model.occurredAt = new Date();
      model.capillarityBloodGlucose = null;
      model.measurementFasting = "other";
    }
    return model;
  }
  get toastMessage() {
    return this.session.patient ? {
      message: "Glycémie enregistrée. Merci !",
      title: "Glycémie"
    } : super.toastMessage;
  }
  get displayInsulinQuestions() {
    const insulin = this.changeset.get("insulin");
    return insulin == "yes" || insulin == "dontKnow";
  }
  get changeset() {
    const changeset = super.changeset;
    this.bloodGlucoseByGram = this.convertToGram(this.changeset.get("capillarityBloodGlucose"));
    this.bloodGlucoseByMmol = this.changeset.get("capillarityBloodGlucose");
    return changeset;
  }
  onBloodGlucoseByGramChanged(e) {
    this.bloodGlucoseByMmol = "";
    const value = e.target.value;
    // Set the value in Mmol in the changeset
    this.changeset.set("capillarityBloodGlucose", value == "" ? "" : this.convertToMmol(value || ""));
  }
  onBloodGlucoseByMmolChanged(e) {
    this.bloodGlucoseByGram = "";
    const value = e.target.value;
    // Set the value in the changeset
    this.changeset.set("capillarityBloodGlucose", value == "" ? "" : value || "");
  }
  convertToGram(value) {
    return this.fixStringValue(CapillarityBloodGlucoseMeasuredJournalEvent.convertToGram(parseFloat(value)));
  }
  convertToMmol(value) {
    return this.fixStringValue(CapillarityBloodGlucoseMeasuredJournalEvent.convertToMmol(parseFloat(value)));
  }
  fixStringValue(value) {
    return value?.toFixed(2).replace(/\.?0+$/, "");
  }
}, _defineProperty(_CapillarityBloodGlucoseEditionFormComponent, "forcDisplayName", "Ma glycémie"), _defineProperty(_CapillarityBloodGlucoseEditionFormComponent, "fullComponentId", "capillarity-blood-glucose/edition-form"), _defineProperty(_CapillarityBloodGlucoseEditionFormComponent, "journalEventClass", CapillarityBloodGlucoseMeasuredJournalEvent), _CapillarityBloodGlucoseEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bloodGlucoseByGram", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bloodGlucoseByMmol", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onBloodGlucoseByGramChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBloodGlucoseByGramChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBloodGlucoseByMmolChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBloodGlucoseByMmolChanged"), _class.prototype), _class);
export { CapillarityBloodGlucoseEditionFormComponent as default };